// components/ToggleSection.jsx
import React from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

const ToggleSection = ({ label, value, onChange, children, containerSx = {} }) => (
  <Box sx={{ marginBottom: 2, ...containerSx }}>
    <FormControlLabel
      control={<Checkbox checked={value} onChange={onChange} />}
      label={label}
    />
    {value && (
      <Box sx={{ display: "flex", flexDirection: "column", marginBottom: 4 }}>
        {children}
      </Box>
    )}
  </Box>
);

export default ToggleSection;
